
import { action } from "typesafe-actions";
import { CountryData, SharedActionTypes } from "./types";

export const getCountriesRequest = () => action(SharedActionTypes.GETCOUNTRIES_REQUEST);
export const getCountriesSuccess = (data: CountryData[]) => action(SharedActionTypes.GETCOUNTRIES_SUCCESS, data);
export const getCountriesError = () => action(SharedActionTypes.GETCOUNTRIES_ERROR);
export const setSessionId = (data: string) => action(SharedActionTypes.SET_SESSION_ID, data)
